import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {confirmMembership} from "../services/controllers";
import {APIPostConfirmMembershipResponse} from "../services/facade";
import MembershipRecap from "../components/MembershipForm/MembershipRecap";
import PaymentRecap from "../components/Confirmation/PaymentRecap";
import ConfirmationRecap from "../components/Confirmation/ConfirmationRecap";

const MembershipConfirmationPage = () => {
    const [searchParams,] = useSearchParams();
    const hash = searchParams.get("hash")

    const [confirmationInfos, setConfirmationInfos] = useState<APIPostConfirmMembershipResponse | null>(null)

    useEffect(() => {
        if (hash) {
            confirmMembership({ hash }).then((data: APIPostConfirmMembershipResponse) => setConfirmationInfos(data))
        }
    }, [hash])

    useEffect(() => {
        if (confirmationInfos && !confirmationInfos?.TRANSACTION_DATE) {
            window.location.replace('error/notFoundPage')
        }
    }, [confirmationInfos, confirmationInfos?.TRANSACTION_DATE])

    return (
        confirmationInfos && confirmationInfos.TRANSACTION_DATE
            ? (
                <div className={"flex flex-col gap-y-8"}>
                    <ConfirmationRecap
                        EMAIL={confirmationInfos.EMAIL}
                        NO_LICENCE={confirmationInfos.NO_LICENCE}
                        ANNEE_LICENCE={confirmationInfos.ANNEE_LICENCE}
                        VALIDITY_START={new Date(confirmationInfos.VALIDITE_DEBUT)}
                        VALIDITY_END={new Date(confirmationInfos.VALIDITE_FIN)}
                    />
                    <PaymentRecap
                        TRANSACTION_DATE={confirmationInfos.TRANSACTION_DATE}
                        TRANSACTION_ID={confirmationInfos.TRANSACTION_ID}
                        TRANSACTION_MONTANT={confirmationInfos.TRANSACTION_MONTANT}
                    />
                    <MembershipRecap
                        birthCity={confirmationInfos.NAISSANCE_COMMUNE}
                        address={confirmationInfos.ADR1}
                        zipCode={confirmationInfos.CODE_POSTAL}
                        city={confirmationInfos.VILLE}
                        country={confirmationInfos.PAYS}
                        phone={confirmationInfos.MOBILE}
                        email={confirmationInfos.EMAIL}
                        discipline={confirmationInfos.SECTEUR}
                        activity={confirmationInfos.ACTIVITE}
                        affiliation={confirmationInfos.ST_CODE_SOUHAITE}
                    />
                </div>
            ) : (<div>Chargement...</div>)
    )
}

export default MembershipConfirmationPage;